import React from "react";
import ERTDetailPage from "./views/ERTDetailPage";
import { ERTDetailContextProvider } from "./ERTDetailView";
import StatusContents from "../../constants/contentFile.json";

const ERTDetailView = () => {
  return (
    <ERTDetailContextProvider>
      <ERTDetailPage textContents={StatusContents.status} />
    </ERTDetailContextProvider>
  );
};
export default ERTDetailView;
